/* istanbul ignore file */
import {Alignment} from '../../productPage/constants';
import {getDisplayCssVars} from '@wix/wixstores-client-storefront-common';
import {getShouldRenderVars} from './shouldRenderVars';
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

const enum FlexAlignment {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
}

export const getCustomCssVars = ({styleParams, isRTL}: CustomCssVarsFnParams) => {
  const getErrorMessageAlignment = () => {
    const defaultAlignmentRtl = isRTL ? Alignment.RIGHT : Alignment.LEFT;
    switch (styleParams.strings.productPage_productDetailsAlignment?.value || defaultAlignmentRtl) {
      case Alignment.LEFT:
        return isRTL ? FlexAlignment.FlexEnd : FlexAlignment.FlexStart;
      case Alignment.RIGHT:
        return isRTL ? FlexAlignment.FlexStart : FlexAlignment.FlexEnd;
      case Alignment.CENTER:
        return FlexAlignment.Center;
    }
  };

  return {
    errorMessageFlexAlignment: getErrorMessageAlignment(),
    imageGalleryPaginationDotsDirection: isRTL ? 'row-reverse' : 'row',
    infoSectionCollapseIconOrder: isRTL ? '0' : '1',
    infoSectionCollapseTitleOrder: isRTL ? '1' : '0',
    infoSectionDirection: isRTL ? 'rtl' : 'ltr',
  };
};

export const customCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams, isMobile, isRTL} = customCssVarsFnParams;
  const shouldRenderVars = getShouldRenderVars({
    booleans: styleParams.booleans,
    numbers: styleParams.numbers,
    isMobile,
    isRTL,
  });

  return {
    ...getDisplayCssVars({...styleParams.booleans, ...shouldRenderVars}),
    ...getCustomCssVars(customCssVarsFnParams),
  };
};
